import { ComponentProps } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import { twMerge } from "tailwind-merge";

import Label from "@/components/form-controls/Label";



export type SelectProps = ComponentProps<"select"> & {
    label?: string,
    labelStyle?: string,
    inputStyle?: string,
    hasError?: boolean
    error? : string,
    register?: UseFormRegisterReturn;
    options: Array<any>;
    valueName?: string;
    displayName?: string;
    hint?: string
    placeholder?: string
}

const SelectInput = ({
    children,
    labelStyle,
    inputStyle,
    defaultValue,
    hasError,
    label,
    options,
    className,
    valueName,
    displayName,
    multiple = false,
    error,
    register,
    hint,
    placeholder,
    ...extra
}: SelectProps) => {

    return (
        <div className={className}>
            <Label 
                name={extra.name ?? ""} 
                text={label} 
                required={extra.required}
                className={labelStyle}
                hint={hint}
            />
            
            <div className={"relative"}>
                <select
                    multiple={multiple}
                    // @ts-ignore
                    defaultValue={defaultValue ? defaultValue : ""}
                    className={twMerge(
                        "input", 
                        hasError ? "input-error" : "input-default cursor-pointer",
                        extra.disabled && "bg-zinc-100",
                        inputStyle
                    )}
                    {...register}
                    {...extra}
                    
                >
                    <option value="" disabled>{placeholder ?? "----------"}</option>
                    {
                        options?.map((item, index) => (
                            <option value={valueName ? item[valueName] : item} key={index}>
                                {displayName ? item[displayName] : item}
                            </option>
                        ))
                    }
                </select>
            </div>

            {
                error &&
                <div className="text-xs text-rose-800 font-medium px-1 pt-1">
                    { error ? error : "field is required" }
                </div>
            }
        </div>
    );
}

export default SelectInput
